import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth';

/** Seed super-admins and organization admins. */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const user = auth.user();
  if (user?.is_system_admin === true || user?.is_org_admin === true) return true;
  return router.createUrlTree(['/projects']);
};
